import { Stack, IconButton, Typography } from '@mui/material';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

interface AudioPlayerButtonsProps {
  playing: boolean;
  togglePlay: VoidFunction;
  progress: number;
  clipLength: number;
}

export const AudioPlayerButtons = ({
  playing,
  togglePlay,
  progress,
  clipLength,
}: AudioPlayerButtonsProps) => {
  return (
    <Stack direction='row' alignItems='center'>
      <IconButton color='primary' onClick={togglePlay}>
        {playing ? <PauseIcon /> : <PlayArrowIcon />}
      </IconButton>
      <Typography>
        {Math.floor(progress)}/{clipLength} sec
      </Typography>
    </Stack>
  );
};
